<ng-template #template>
  <ng-container *ngIf="!!this.survey && !!this.model && this.model.isVisible && !!this.model.survey">
    <div [class]="model.cssRoot" #pageContainer>
      <sv-ng-element-title [element]="model"></sv-ng-element-title>
      <div *ngIf="model._showDescription" [class]="model.cssClasses.page?.description">
        <sv-ng-string [model]="model.locDescription"></sv-ng-string>
      </div>
      <div *ngIf="model.hasVisibleErrors" [element]="model" sv-ng-errors></div>
      <ng-container *ngFor="let row of model.visibleRows">
        <ng-template [component]="{ name: $any(model.survey).getRowWrapperComponentName(row), data: { componentData: $any(model.survey).getRowWrapperComponentData(row) } }">
          <sv-ng-row [row]="row"></sv-ng-row>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>  
</ng-template>